import { useAtomValue } from "jotai";
import { EmployeeRowItem, IEmployeeEnrollment } from "library/types";
import { companyPackagesState } from "store/UIHrPage";
import styled from "styled-components";
import PackageRowItem from "./PackageRowItem";

type Props = {
  employeeData: EmployeeRowItem;
  enrollment: EmployeeRowItem;
  showDeleteOption?: boolean;
  showManagePackageEligibilityOption?: boolean;
};
export function EnrolledEmployeeRow({
  employeeData,
  enrollment,
  showDeleteOption,
  showManagePackageEligibilityOption,
}: Props) {
  const companyPackageObject = useAtomValue(companyPackagesState);

  const enrolledPackage = (employeeData.enrollments || []).find((enroll) => {
    return enroll.employeeEnrollmentTag === enrollment.employeeEnrollmentTag;
  });

  let packageFullLData = enrolledPackage
    ? (companyPackageObject || {})[enrolledPackage.benefitPackageTag]
    : null;
  if (packageFullLData === undefined) {
    packageFullLData = enrolledPackage;
  }
  return (
    <Container>
      <PackageRowItem
        enrolledPackage={enrolledPackage as IEmployeeEnrollment}
        packageData={packageFullLData}
        packageUser={employeeData}
        enrollment={enrollment}
        showDeleteOption={showDeleteOption}
        showManagePackageEligibilityOption={showManagePackageEligibilityOption}
      />
    </Container>
  );
}

const Container = styled.div`
  box-shadow: 16px 0px 32px 0px rgba(5, 54, 69, 0.06);
  padding-right: 10px;
`;
